/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import SwaggerApi from './SwaggerApi';

class CoreApi extends SwaggerApi {
  constructor(apiOptions = {}) {
    super({
      api: '/api/v0',
      ...apiOptions,
    });

    this.init();
  }

  login = async (name, password) => {
    await this.init();
    const loginResponse = (
      await this.apis.default.login_post({
        user: { name, password },
      })
    ).obj;

    return loginResponse;
  };
}

export default new CoreApi();
